import { HomeIcon, ChevronRightIcon } from "./icons";

export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="mb-4 overflow-visible sm:mb-0" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-x-1 gap-y-2 md:gap-x-3">
        {items.map((item, index) => {
          const isFirst = index === 0;

          return (
            <li
              key={index}
              className={isFirst ? "inline-flex items-center" : undefined}
            >
              <div className={isFirst ? undefined : "flex items-center"}>
                {!isFirst && (
                  <span className="shrink-0">
                    <ChevronRightIcon />
                  </span>
                )}

                {item.onClick ? (
                  <button
                    type="button"
                    onClick={item.onClick}
                    className={
                      isFirst
                        ? "inline-flex items-center text-xs font-medium text-gray-600 transition-colors hover:text-gray-900 sm:text-sm"
                        : "ml-1 text-xs font-medium text-gray-600 transition-colors hover:text-gray-900 sm:text-sm md:ml-2"
                    }
                  >
                    {isFirst && <HomeIcon />}
                    {item.label}
                  </button>
                ) : item.href ? (
                  <a
                    href={item.href}
                    className={
                      isFirst
                        ? "inline-flex items-center text-xs font-medium text-gray-600 transition-colors hover:text-gray-900 sm:text-sm"
                        : "ml-1 text-xs font-medium text-gray-600 transition-colors hover:text-gray-900 sm:text-sm md:ml-2"
                    }
                  >
                    {isFirst && <HomeIcon />}
                    {item.label}
                  </a>
                ) : (
                  <span className="ml-1 text-xs font-medium text-gray-500 sm:text-sm md:ml-2">
                    {item.label}
                  </span>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
